import { render } from "./examinerchaxun.vue?vue&type=template&id=2b91c4af&scoped=true"
import script from "./examinerchaxun.vue?vue&type=script&lang=js"
export * from "./examinerchaxun.vue?vue&type=script&lang=js"

import "./examinerchaxun.vue?vue&type=style&index=0&id=2b91c4af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b91c4af"

export default script